import type { SourceRoleContract } from "./types";


export function SourceSectionNavigation({ roles }: { roles: SourceRoleContract[] }) {
  return <nav className="source-section-navigation" aria-label="Navigation des sources">
    <a href="#source-summary">Résumé</a>
    {roles.map((role) => <a key={role.role} href={`#source-role-${role.role}`}>{role.label}</a>)}
    <a href="#source-history">Historique</a>
  </nav>;
}
